import { EventEmitter, Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { QuestionTypes } from '../classes/question-types';
import { ApiRequestService } from './api-request.service';
import { DomSanitizer,SafeHtml } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class QuestionService {
  public questions:any[] =[];
  public surveyQuestions:any ={};
  public utg_id:string = '';
  public currentQuestion:any = {};
  public quesType:string = '';
  public finalAnswers:any= [];
  public filterCityArr:any = [];
  public params:any;
  public questionType:QuestionTypes = new QuestionTypes();
  public refreshAnsBody = new EventEmitter<string>();
  public questionView:any = {"colSpan":1,"isImgOption":false, "optionSize":6};
  public screenTemplate:any;
  public screenTemplateDetails:any = {};
  public noSplash:boolean = true;

  constructor(
        private activatedRoute:ActivatedRoute,
        private apiRequest: ApiRequestService, 
        private router:Router,
        public sanitizer: DomSanitizer
    ) { }

  initSurvay(params:any){
    // console.log("environment.surveyUrl  ",environment.surveyUrl)
    this.params = params;
    this.quesType = "";
    this.currentQuestion = {};
    this.getSurveyQuestions(params);
    // this.getTestQuestions(params);
  }

//   getFilterArray(){
//     let arr = this.getQuestions().questions[2];
//     let city_arr = this.citOption();
//     city_arr = city_arr.sort((one, two) => (one > two ? 1 : -1));
//     this.filterCityArr = city_arr?.map((city:string,index:number) => ({'id':index+1,'name':city}));
//   }
  
  setQuestionView(){
    //   this.questionView = {"colSpan":1,"isImgOption":true};
      this.questionView['colSpan']= this.currentQuestion.colspan ? this.currentQuestion.colspan :1;
      let checkImageUrlInOption:any = {}
      if (Array.isArray(this.currentQuestion.options)){
        checkImageUrlInOption = this.currentQuestion.options.find((item:any) => { return item.img_url && item.img_url.trim() !=''})
      }else{
        checkImageUrlInOption = this.currentQuestion.options;
      }
      this.questionView['isImgOption']= (checkImageUrlInOption && checkImageUrlInOption["img_url"] && checkImageUrlInOption["img_url"] !="") ? true :false;
      
    }


  getNextQuestion(){
    if (Object.keys(this.currentQuestion).length == 0 && this.questions.length >0 ) {
      this.currentQuestion = this.questions[0]
      this.currentQuestion['ques_index'] = 1;
      this.setQuestionView()
    }else{
      let index = this.questions.findIndex(item => item.question_id == this.currentQuestion.question_id);
      if (index+1 >= this.questions.length) {
        // let urlStr = '';

        // loop to create body for post call 
        var body:any = {"id":this.params.request_id, "data":{}}
        this.finalAnswers.forEach((ans:any, index:number) => {
            if (typeof(ans["answer_text"]) == 'object') {
                if (Array.isArray(ans["answer_text"])) {
                    body["data"][ans["question_name"]] = [];
                    for (let i = 0; i < ans["answer_text"].length; i++) {
                        body["data"][ans["question_name"]].push(ans["answer_text"][i]["text"]);
                    }
                }else{
                    body["data"][ans["question_name"]]=[ans["answer_text"]["text"]];
                }
            }else{
                body["data"][ans["question_name"]]=[ans["answer_text"]];
            }
          });
        // console.log("finalAnswers body is =====>",body)
        if (this.utg_id && this.utg_id != '') {
            this.submitAnswer(body)
        }else{
          this.currentQuestion = {"question_type":"complete"};
        }
      }else{
        let previousQuestionType = this.currentQuestion['question_type']
        this.currentQuestion = this.questions[index+1];
        this.setQuestionView();
        if (previousQuestionType == this.currentQuestion['question_type']) {
            this.refreshAnsBody.emit(previousQuestionType);
        }
        this.currentQuestion['ques_index'] = index+2;
      }
    }
    // console.log(this.currentQuestion)
  }

  getQuestions(){
    return this.surveyQuestions;
  }





  getSurveyQuestions(params:any){
    
    this.getQuestionsApi(params)
      .subscribe({
        next: (response:any) =>{
          if (response['status'] == 1) {
            this.surveyQuestions["demography"] = response['demography'];
            this.surveyQuestions["questions"] = response['questions'];
            if(this.surveyQuestions["demography"]){
                this.questions = response['questions'];
                if (response['template_details']) {
                    this.screenTemplateDetails = response['template_details'];
                }
                this.getNextQuestion();
            }else{
                if(response && response['screen']){
                    this.screenTemplate = this.sanitizer.bypassSecurityTrustHtml(response['template']);
                    this.screenTemplateDetails = response['template_details'];
                    this.noSplash = params['demoScreen'] ? false : true;
                }else{
                    window.location.href = environment.surveyUrl+'/utg/'+this.utg_id;
                }

            }
          }
        },
        error: (e) =>{
          console.log(e)
        }
      });

  }

  getDummyResponse(){
    return {
	"status": 1,
	"demography": true,
	"questions": [
		{
			"question_id": 1,
			"question_label": "Gender",
			"question_name": "gender",
			"question_type": "single-select",
			"question_text": "What is your Gender?",
			"colspan": 1,
			"options": [
				{
					"id": 1,
					"text": "Male",
					"label": "male",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 2,
					"text": "Female",
					"label": "female",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				}
			],
			"misc": {
				"text": "What is your Gender?"
			}
		},
		{
			"question_id": 2,
			"question_label": "Age",
			"question_name": "age",
			"question_type": "open-end",
			"question_text": "What is your Age?",
			"colspan": 1,
			"options": "1-100",
			"misc": {
				"text": "What is your Age?",
				"ans_type": "numeric",
				"regex": "/^[0-9]*$/"
			}
		},
		{
			"question_id": 3,
			"question_label": "City",
			"question_name": "city",
			"question_type": "multiple-choice-single",
			"question_text": "Which city do you live in?",
			"colspan": 1,
			"options": [
				{
					"id": 0,
					"text": "Tamil Nadu",
					"label": "Tamil Nadu"
				},
				{
					"id": -999,
					"text": "Other",
					"label": "Other"
				}
			],
			"misc": {
				"text": "Which city do you live in?"
			}
		},
		{
			"question_id": 8,
			"question_label": "SEC-A",
			"question_name": "sec-a",
			"question_type": "multiple-choice-multiple-select",
			"question_text": "Which of these ITEMS do you have at home? (It could be owned by you, your family, the owner of the house, or provided by your employer)",
			"colspan": 2,
			"options": [
				{
					"id": 3,
					"text": "Electricity Connection",
					"label": "Electricity Connection",
					"miscellaneous": {
						"img_url": "sec/sec_electricity.png"
					},
					"img_url": "sec/sec_electricity.png",
					"locale": {}
				},
				{
					"id": 4,
					"text": "Ceiling Fan",
					"label": "Ceiling Fan",
					"miscellaneous": {
						"img_url": "sec/sec_fan.png"
					},
					"img_url": "sec/sec_fan.png",
					"locale": {}
				},
				{
					"id": 5,
					"text": "LPG Stove",
					"label": "LPG Stove",
					"miscellaneous": {
						"img_url": "sec/sec_gas.png"
					},
					"img_url": "sec/sec_gas.png",
					"locale": {}
				},
				{
					"id": 6,
					"text": "Two Wheeler",
					"label": "Two Wheeler",
					"miscellaneous": {
						"img_url": "sec/sec_bike.png"
					},
					"img_url": "sec/sec_bike.png",
					"locale": {}
				},
				{
					"id": 7,
					"text": "Color TV",
					"label": "Color TV",
					"miscellaneous": {
						"img_url": "sec/sec_tv.png"
					},
					"img_url": "sec/sec_tv.png",
					"locale": {}
				},
				{
					"id": 8,
					"text": "Refrigerator",
					"label": "Refrigerator",
					"miscellaneous": {
						"img_url": "sec/sec_fridge.png"
					},
					"img_url": "sec/sec_fridge.png",
					"locale": {}
				},
				{
					"id": 9,
					"text": "Personal Computer/Laptop",
					"label": "Personal Computer/Laptop",
					"miscellaneous": {
						"img_url": "sec/sec_laptop.png"
					},
					"img_url": "sec/sec_laptop.png",
					"locale": {}
				},
				{
					"id": 10,
					"text": "Washing Machine",
					"label": "Washing Machine",
					"miscellaneous": {
						"img_url": "sec/sec_washing.png"
					},
					"img_url": "sec/sec_washing.png",
					"locale": {}
				},
				{
					"id": 11,
					"text": "Air Conditioner",
					"label": "Air Conditioner",
					"miscellaneous": {
						"img_url": "sec/sec_ac.png"
					},
					"img_url": "sec/sec_ac.png",
					"locale": {}
				},
				{
					"id": 12,
					"text": "Car/Jeep/Van",
					"label": "Car/Jeep/Van",
					"miscellaneous": {
						"img_url": "sec/sec_car.png"
					},
					"img_url": "sec/sec_car.png",
					"locale": {}
				},
				{
					"id": 13,
					"text": "Agricultural Land",
					"label": "Agricultural Land",
					"miscellaneous": {
						"img_url": "sec/sec_agriculture.png"
					},
					"img_url": "sec/sec_agriculture.png",
					"locale": {}
				}
			],
			"misc": {
				"text": "Which of these ITEMS do you have at home? (It could be owned by you, your family, the owner of the house, or provided by your employer)",
				"colspan": 2
			}
		},
		{
			"question_id": 9,
			"question_label": "SEC-C",
			"question_name": "sec-c",
			"question_type": "multiple-choice-single",
			"question_text": "What is the highest education of the PERSON WHO MAKES the biggest contribution to the running of the household?",
			"colspan": 1,
			"options": [
				{
					"id": 14,
					"text": "Graduate / Post Graduate -Professional",
					"label": "Graduate / Post Graduate -Professional",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 15,
					"text": "Graduate / Post Graduate - General",
					"label": "Graduate / Post Graduate - General",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 16,
					"text": "Some College (including a Diploma) but not graduate",
					"label": "Some College (including a Diploma) but not graduate",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 17,
					"text": "SSC / HSC",
					"label": "SSC / HSC",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 18,
					"text": "School 5 to 9 years",
					"label": "School 5 to 9 years",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 19,
					"text": "Literate but no formal schooling / School up to 4 years",
					"label": "Literate but no formal schooling / School up to 4 years",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				},
				{
					"id": 20,
					"text": "Illiterate",
					"label": "Illiterate",
					"miscellaneous": null,
					"img_url": null,
					"locale": {}
				}
			],
			"misc": {
				"text": "What is the highest education of the PERSON WHO MAKES the biggest contribution to the running of the household?"
			}
		}
	],
	"screen": false,
	"template": "<div        style=\"background-color: #fff;        align-items: center; display: flex;        flex-direction: column; justify-content: space-between; align-items: center; text-align: center;\"     >       <div class=\"ques-cont\">         <div>             <img style=\"margin-top: 15px;\" src=\"https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714017537_m2x.png\" alt=\"\" />         </div>         <div class=\"survey-head\" style=\"margin: 10px; color: #0d6efd ; font-family:'Roboto',sans-serif; font-size:25px; line-height:25px; font-weight: 700;\">             This is a Demographic survey         </div>         <div class=\"survey-head\" style=\"margin: 10px; color: #000 ; font-family:'Roboto',sans-serif; font-size:20px; line-height:25px; font-weight: 700;\">             You will be asked to complete             your profile firstly then after you will be redirected to the main survey.         </div>         <div class=\"survey-head\" style=\"margin: 10px; color: #6c757d  ; font-family:'Roboto',sans-serif; font-size:20px; line-height:25px; font-weight: 600;\">             No rewards are given on              completing profile.         </div>         <div class=\"mt-4\">             <img class=\"Image-Section\" style=\"margin-top: 10px; width: 250px; height: 180px;\" src=\"https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1714017647_group22x.png\" alt=\"\" />         </div>       </div>     </div>",
	"template_details": {
		"header_logo": "https://s3-ap-southeast-1.amazonaws.com/images.crownit.in/promotion/1713962719_m2x.png",
		"header_text": "Mcollector",
		"footer_btn_text": "Proceed"
	}
}
  }

  getTestQuestions(params:any){

    let response = this.testResponse();
        if (response['status'] == 1) {
            this.surveyQuestions["demography"] = response['demography'];
            this.surveyQuestions["questions"] = response['questions'];
            if(this.surveyQuestions["demography"]){
                this.questions = response['questions'];
                this.getNextQuestion();
            }else{
                window.location.href = environment.surveyUrl+'/utg/'+this.utg_id;
            }
        }

  }

  getQuestionsApi(params:any){
      let opt = {};
      var url = "/demography/survey?sid="+params.sid;
      if (params.demoScreen) { url += "&demoScreen="+params.demoScreen}
      if (params.survey_id) { url += "&survey_id="+params.survey_id }
      if (params.request_id) { url += "&request_id="+params.request_id }

    //   console.log("url is ===>",url)
      return this.apiRequest.request('GET',url,{},opt);
    // return this.apiRequest.request('GET','/demography/survey?survey_id=e5d5703d-1230-11ed-b92f-f0d5bfd3c881&request_id=abcd1&sid=16127d4e-122e-11ed-b92f-f0d5bfd3c881',{},opt);
  }

  submitAnswer(body:any){
    let opt = {};      
    this.apiRequest.request('POST',"/saveusercags",body,opt)
      .subscribe({
        next: (response:any) =>{
            // console.log("redirect url is ====> ",environment.surveyUrl+'/utg/'+this.utg_id)
          if (response['status'] == 1) {
            if (this.params.survey_id) { 
                window.location.href = environment.surveyUrl+'/utg/'+this.utg_id+'?survey_id='+this.params.survey_id; 
            }else{
                window.location.href = environment.surveyUrl+'/utg/'+this.utg_id;
            }
          }
        },
        error: (e) =>{
          console.log(e)
        }
      });
  }

  submitSingleAnswer(data:any){
    let body:any = {"id":this.params.request_id, "data":data}
    let opt = {};      
    this.apiRequest.request('POST',"/saveusercags",body,opt)
      .subscribe({
        next: (response:any) =>{
        //   if (response['status'] == 1) {
        //     debugger
        //   }
        },
        error: (e) =>{
          console.log(e)
        }
      });
  }

  testResponse(){

    return {
        "status": 1,
        "demography": true,
        "questions": [
            // {
            //     "question_id": 1,
            //     "question_label": "Gender",
            //     "question_name": "gender",
            //     "question_type": "single-select",
            //     "question_text": "What is your Gender?",
            //     "colspan": 1,
            //     "options": [
            //         {
            //             "id": 1,
            //             "text": "Male",
            //             "label": "male",
            //             "miscellaneous": null,
            //             "img_url": null,
            //             "locale": {}
            //         },
            //         {
            //             "id": 2,
            //             "text": "Female",
            //             "label": "female",
            //             "miscellaneous": null,
            //             "img_url": null,
            //             "locale": {}
            //         }
            //     ],
            //     "misc": {
            //         "text": "What is your Gender?"
            //     }
            // },
            // {
            //     "question_id": 2,
            //     "question_label": "Age",
            //     "question_name": "age",
            //     "question_type": "open-end",
            //     "question_text": "What is your Age?",
            //     "colspan": 1,
            //     "options": "1-100",
            //     "misc": {
            //         "text": "What is your Age?",
            //         "ans_type": "numeric",
            //         "regex": "/^[0-9]*$/"
            //     }
            // },
            // {
            //     "question_id": 3,
            //     "question_label": "City",
            //     "question_name": "city",
            //     "question_type": "single-select-dropdown",
            //     "question_text": "Which city do you live in?",
            //     "colspan": 1,
            //     "options": [
            //         "Gurugram",
            //         "New Delhi",
            //         "Ghaziabad",
            //         "Noida",
            //         "Faridabad",
            //         "Mumbai",
            //         "Shimla",
            //         "Bengaluru",
            //         "Thane",
            //         "Udaipur",
            //         "Amritsar(Hotels)",
            //         "Goa",
            //         "Jaipur",
            //         "Mahabaleshwar",
            //         "Manali",
            //         "Jaisalmer",
            //         "Lonavala",
            //         "Ooty",
            //         "Daman",
            //         "Coorg",
            //         "Aurangabad",
            //         "Pondicherry",
            //         "Rishikesh",
            //         "Alibag",
            //         "Alleppey",
            //         "Shirdi",
            //         "Mussoorie",
            //         "Chandigarh",
            //         "Pune",
            //         "Katra",
            //         "Munnar",
            //         "Nainital",
            //         "Dombivli",
            //         "Kalyan",
            //         "Navi Mumbai",
            //         "Hyderabad",
            //         "Ahmedabad",
            //         "Kolkata",
            //         "Mysore",
            //         "Kanpur",
            //         "Amritsar",
            //         "Aurangabad",
            //         "Nashik",
            //         "Allahabad",
            //         "Varanasi",
            //         "Ranchi",
            //         "Patna",
            //         "Dehradun",
            //         "Agra",
            //         "Mangalore",
            //         "Surat",
            //         "Ludhiana",
            //         "Nagpur",
            //         "Indore",
            //         "Vadodara",
            //         "Bhopal",
            //         "Guwahati",
            //         "Kochi",
            //         "Lucknow",
            //         "Puducherry",
            //         "Udaipur(do not use)",
            //         "Visakhapatnam",
            //         "Chennai",
            //         "Haridwar",
            //         "Kodaikanal",
            //         "Kovalam",
            //         "Manipal",
            //         "Pushkar",
            //         "Meerut",
            //         "Rajkot",
            //         "Solapur",
            //         "Srinagar",
            //         "Dhanbad",
            //         "Howrah",
            //         "Coimbatore",
            //         "Jabalpur",
            //         "Gwalior",
            //         "Vijayawada",
            //         "Jodhpur",
            //         "Madurai",
            //         "Raipur",
            //         "Kota",
            //         "Bareilly",
            //         "Moradabad",
            //         "Aligarh",
            //         "Jalandhar",
            //         "Tiruchirappalli",
            //         "Salem",
            //         "Thiruvananthapuram",
            //         "Bhiwandi",
            //         "Saharanpur",
            //         "Gorakhpur",
            //         "Guntur",
            //         "Bikaner",
            //         "Amravati",
            //         "Jamshedpur",
            //         "Bhilai",
            //         "Cuttack",
            //         "Firozabad",
            //         "Bhavnagar",
            //         "Durgapur",
            //         "Asansol",
            //         "Nanded",
            //         "Kolhapur",
            //         "Ajmer",
            //         "Gulbarga",
            //         "Jamnagar",
            //         "Ujjain",
            //         "Loni",
            //         "Siliguri",
            //         "Jhansi",
            //         "Ulhasnagar",
            //         "Nellore",
            //         "Jammu",
            //         "Belgaum",
            //         "Ambattur",
            //         "Tirunelveli",
            //         "Malegaon",
            //         "Gaya",
            //         "Jalgaon",
            //         "Maheshtala",
            //         "Tirupur",
            //         "Davanagere",
            //         "Calicut",
            //         "Akola",
            //         "Kurnool",
            //         "Rajpur Sonarpur",
            //         "Bokaro",
            //         "South Dumdum",
            //         "Bellary",
            //         "Patiala",
            //         "Gopalpur",
            //         "Agartala",
            //         "Bhagalpur",
            //         "Muzaffarnagar",
            //         "Panihati",
            //         "Latur",
            //         "Dhule",
            //         "Rohtak",
            //         "Korba",
            //         "Bhilwara",
            //         "Brahmapur",
            //         "Muzaffarpur",
            //         "Ahmednagar",
            //         "Mathura",
            //         "Kollam",
            //         "Avadi",
            //         "Rajahmundry",
            //         "Kadapa",
            //         "Kamarhati",
            //         "Bilaspur",
            //         "Shahjahanpur",
            //         "Bijapur",
            //         "Rampur",
            //         "Shimoga",
            //         "Chandrapur",
            //         "Junagadh",
            //         "Thrissur",
            //         "Alwar",
            //         "Bardhaman",
            //         "Kulti",
            //         "Nizamabad",
            //         "Parbhani",
            //         "Tumkur",
            //         "Hisar",
            //         "Ozhukarai",
            //         "Bihar Sharif",
            //         "Tiruppur",
            //         "Bhubaneswar",
            //         "Warangal",
            //         "Sangli-Miraj & Kupwad",
            //         "Erode",
            //         "Kozhikode",
            //         "Bhatpara",
            //         "Tirupati",
            //         "Berhampur",
            //         "Shivamogga",
            //         "Kakinada",
            //         "Khammam",
            //         "Panipat",
            //         "Darbhanga",
            //         "Bally",
            //         "Aizawl",
            //         "Dewas",
            //         "Ichalkaranji",
            //         "Karnal",
            //         "Bathinda",
            //         "Jalna",
            //         "Eluru",
            //         "Barasat",
            //         "Purnia",
            //         "Satna",
            //         "Mau",
            //         "Sonipat",
            //         "Farrukhabad",
            //         "Sagar",
            //         "Rourkela",
            //         "Durg",
            //         "Imphal",
            //         "Ratlam",
            //         "Hapur",
            //         "Arrah",
            //         "Karimnagar",
            //         "Anantapur",
            //         "Etawah",
            //         "Ambernath",
            //         "North Dumdum",
            //         "Bharatpur",
            //         "Begusarai",
            //         "Gandhidham",
            //         "Baranagar",
            //         "Tiruvottiyur",
            //         "Sikar",
            //         "Thoothukudi",
            //         "Rewa",
            //         "Mirzapur",
            //         "Raichur",
            //         "Pali",
            //         "Ramagundam",
            //         "Vijayanagaram",
            //         "Katihar",
            //         "Nagarcoil",
            //         "Sri Ganganagar",
            //         "Mango",
            //         "Thanjavur",
            //         "Bulandshahr",
            //         "Uluberia",
            //         "Murwara",
            //         "Sambhal",
            //         "Singrauli",
            //         "Nadiad",
            //         "Secunderabad",
            //         "Naihati",
            //         "Yamunanagar",
            //         "Bidhan Nagar",
            //         "Pallavaram",
            //         "Bidar",
            //         "Munger",
            //         "Panchkula",
            //         "Burhanpur",
            //         "Raurkela Industrial Township",
            //         "Kharagpur",
            //         "Dindigul",
            //         "Gandhinagar",
            //         "Hospet",
            //         "English Bazar",
            //         "Ongole",
            //         "Deoghar",
            //         "Chapra",
            //         "Haldia",
            //         "Khandwa",
            //         "Nandyal",
            //         "Chittoor",
            //         "Morena",
            //         "Amroha",
            //         "Anand",
            //         "Bhind",
            //         "Madhyamgram",
            //         "Bhiwani",
            //         "Baharampur",
            //         "Ambala",
            //         "Morvi",
            //         "Fatehpur",
            //         "Rae Bareli",
            //         "Khora",
            //         "Bhusawal",
            //         "Orai",
            //         "Bahraich",
            //         "Vellore",
            //         "Mahesana",
            //         "Sambalpur",
            //         "Raiganj",
            //         "Sirsa",
            //         "Danapur",
            //         "Serampore",
            //         "Guna",
            //         "Jaunpur",
            //         "Shivpuri",
            //         "Surendranagar Dudhrej",
            //         "Unnao",
            //         "Hugli and Chinsurah",
            //         "Alappuzha",
            //         "Kottayam",
            //         "Machilipatnam",
            //         "Adoni",
            //         "Tenali",
            //         "Proddatur",
            //         "Saharsa",
            //         "Hindupur",
            //         "Bettiah",
            //         "Palakollu",
            //         "Guntakal",
            //         "Srikakulam",
            //         "Motihari",
            //         "Gudivada",
            //         "Narasaraopet",
            //         "Suryapet",
            //         "Tadipatri",
            //         "Kishanganj",
            //         "Karaikudi",
            //         "Miryalaguda",
            //         "Kavali",
            //         "Tadepalligudem",
            //         "Amaravati",
            //         "Veraval",
            //         "Banda",
            //         "Krishnanagar",
            //         "Barrackpur",
            //         "Lakhimpur",
            //         "Santipur",
            //         "Porbandar",
            //         "Balurghat",
            //         "Bhadravati",
            //         "Hanumangarh",
            //         "Moga",
            //         "Pathankot",
            //         "Hajipur",
            //         "Sasaram",
            //         "Habra",
            //         "Bid",
            //         "Mohali",
            //         "Beawar",
            //         "Abohar",
            //         "Tiruvannamalai",
            //         "Jamuria",
            //         "Kaithal",
            //         "Godhra",
            //         "Bhuj",
            //         "Robertson Pet",
            //         "Shillong",
            //         "Rewari",
            //         "Hazaribag",
            //         "Bhimavaram",
            //         "Mandsaur",
            //         "Chas",
            //         "Rudrapur",
            //         "Chitradurga",
            //         "Kumbakonam",
            //         "Dibrugarh",
            //         "Kolar",
            //         "Chhindwara",
            //         "Bankura",
            //         "Mandya",
            //         "Dehri",
            //         "Raigarh",
            //         "Madanapalle",
            //         "Nalgonda",
            //         "Hathras",
            //         "Malerkotla",
            //         "Siwan",
            //         "Chhattarpur",
            //         "Hassan",
            //         "Lalitpur",
            //         "Gondiya",
            //         "North Barrackpur",
            //         "Palakkad",
            //         "Rajapalayam",
            //         "Botad",
            //         "Modinagar",
            //         "Deoria",
            //         "Raniganj",
            //         "Palwal",
            //         "Khanna",
            //         "Neemuch",
            //         "Pilibhit",
            //         "Mustafabad",
            //         "Hardoi",
            //         "Pithampur",
            //         "Dhaulpur",
            //         "Nabadwip",
            //         "Patan",
            //         "Jagdalpur",
            //         "Udupi",
            //         "Basirhat",
            //         "Damoh",
            //         "Halisahar",
            //         "Jagadhri",
            //         "Rishra",
            //         "Kurichi",
            //         "Dimapur",
            //         "Palanpur",
            //         "Dharmavaram",
            //         "Kashipur",
            //         "Ashokenagar Kalyangarh",
            //         "Baidyabati",
            //         "Sawai Madhopur",
            //         "Puruliya",
            //         "Mandoli",
            //         "Mainpuri",
            //         "Kanchrapara",
            //         "Satara",
            //         "Churu",
            //         "Madavaram",
            //         "Gangapur",
            //         "Dabgram",
            //         "Darjiling",
            //         "Barshi",
            //         "Etah",
            //         "Jhunjhunun",
            //         "Chikmagalur",
            //         "Jetpur Navagadh",
            //         "Roorkee",
            //         "Baleshwar",
            //         "Baran",
            //         "Hoshangabad",
            //         "Nagaon",
            //         "Pudukkottai",
            //         "Adilabad",
            //         "Hosur",
            //         "Muktsar",
            //         "Yavatmal",
            //         "Titagarh",
            //         "Barnala",
            //         "Chittaurgarh",
            //         "Dum Dum",
            //         "Basti",
            //         "Valsad",
            //         "Ambur",
            //         "Giridih",
            //         "Chandausi",
            //         "Gonda",
            //         "Bally Town",
            //         "Kalol",
            //         "Bagaha",
            //         "Ambikapur",
            //         "Achalpur",
            //         "Gondal",
            //         "Bagalkot",
            //         "Osmanabad",
            //         "Akbarpur",
            //         "Champdani",
            //         "Deesa",
            //         "Khurja",
            //         "Nandurbar",
            //         "Azamgarh",
            //         "Ghazipur",
            //         "Firozpur",
            //         "Baripada",
            //         "Mughalsarai",
            //         "Anantnag",
            //         "Sehore",
            //         "Bongaon",
            //         "Kanpur Cantonment",
            //         "Khardaha",
            //         "Tadpatri",
            //         "Port Blair",
            //         "Sultanpur",
            //         "Bhadrak",
            //         "Shikohabad",
            //         "Jalpaiguri",
            //         "Shamli",
            //         "Karaikkudi",
            //         "Khargone",
            //         "Wardha",
            //         "Ranibennur",
            //         "Neyveli",
            //         "Amreli",
            //         "Gangawati",
            //         "Hindaun",
            //         "Jamalpur",
            //         "Bhiwadi",
            //         "Ballia",
            //         "Bansberia",
            //         "Baraut",
            //         "Udgir",
            //         "Betul",
            //         "Bundi",
            //         "Jehanabad",
            //         "Ambala Sadar",
            //         "Nagapattinam",
            //         "Nagaur",
            //         "Buxar",
            //         "Seoni",
            //         "Greater Noida",
            //         "Hinganghat",
            //         "Sujangarh",
            //         "Bhadreswar",
            //         "Chilakaluripet",
            //         "Kasganj",
            //         "Kalyani",
            //         "Gangtok",
            //         "Datia",
            //         "Nagda",
            //         "Banswara",
            //         "Kapurthala",
            //         "Hubli",
            //         "Tezpur",
            //         "Dispur",
            //         "Silchar",
            //         "Jorhat",
            //         "Puri",
            //         "Itanagar",
            //         "Panaji",
            //         "North 24 Parganas",
            //         "South 24 Parganas",
            //         "Thiruvallur",
            //         "Malappuram",
            //         "Kannur",
            //         "Gurdaspur",
            //         "Ranga Reddy",
            //         "East Godavari",
            //         "Krishna",
            //         "Belagavi",
            //         "Palghar",
            //         "Dankuni",
            //         "Adampur",
            //         "Peraiyur",
            //         "Tumsar",
            //         "Bagdogra",
            //         "Bongaigaon",
            //         "Diphu",
            //         "Dhubri",
            //         "North Lakhimpur",
            //         "Karimganj",
            //         "Sivasagar",
            //         "Goalpara",
            //         "Barpeta Town",
            //         "Golaghat",
            //         "Haflong",
            //         "Lanka",
            //         "Hojai",
            //         "Barpeta Road",
            //         "Kokrajhar",
            //         "Hailakandi",
            //         "Morigaon",
            //         "Nalbari",
            //         "Rangia",
            //         "Mangaldai",
            //         "Silapathar",
            //         "Dhekiajuli",
            //         "Dergaon",
            //         "Sonari",
            //         "Kanyakumari",
            //         "Badaun",
            //         "Baghpat",
            //         "Gautam Buddha Nagar",
            //         "Bijnor",
            //         "Shaheed Bhagat Singh Nagar ",
            //         "Kasaragod",
            //         "Sitamarhi",
            //         "Karimpur",
            //         "Kurukshetra",
            //         "Medinapur",
            //         "Khordha",
            //         "Tinsukia",
            //         "Charaidep",
            //         "Charaideo",
            //         "Dhemaji",
            //         "Karur",
            //         "Namakkal",
            //         "Najafgarh",
            //         "Rajpura",
            //         "Burdwan"
            //     ],
            //     "misc": {
            //         "text": "Which city do you live in?"
            //     }
            // },
            {
                "question_id": 8,
                "question_label": "SEC-A",
                "question_name": "sec-a",
                "question_type": "multiple-choice-multiple-select",
                "question_text": "Which of these ITEMS do you have at home? (It could be owned by you, your family, the owner of the house, or provided by your employer)",
                "colspan": 2,
                "options": [
                    {
                        "id": 3,
                        "text": "Electricity Connection",
                        "label": "Electricity Connection",
                        "miscellaneous": {
                            "img_url": "sec/sec_electricity.png"
                        },
                        "img_url": "sec/sec_electricity.png",
                        "locale": {}
                    },
                    {
                        "id": 4,
                        "text": "Ceiling Fan",
                        "label": "Ceiling Fan",
                        "miscellaneous": {
                            "img_url": "sec/sec_fan.png"
                        },
                        "img_url": "sec/sec_fan.png",
                        "locale": {}
                    },
                    {
                        "id": 5,
                        "text": "LPG Stove",
                        "label": "LPG Stove",
                        "miscellaneous": {
                            "img_url": "sec/sec_gas.png"
                        },
                        "img_url": "sec/sec_gas.png",
                        "locale": {}
                    },
                    {
                        "id": 6,
                        "text": "Two Wheeler",
                        "label": "Two Wheeler",
                        "miscellaneous": {
                            "img_url": "sec/sec_bike.png"
                        },
                        "img_url": "sec/sec_bike.png",
                        "locale": {}
                    },
                    {
                        "id": 7,
                        "text": "Color TV",
                        "label": "Color TV",
                        "miscellaneous": {
                            "img_url": "sec/sec_tv.png"
                        },
                        "img_url": "sec/sec_tv.png",
                        "locale": {}
                    },
                    {
                        "id": 8,
                        "text": "Refrigerator",
                        "label": "Refrigerator",
                        "miscellaneous": {
                            "img_url": "sec/sec_fridge.png"
                        },
                        "img_url": "sec/sec_fridge.png",
                        "locale": {}
                    },
                    {
                        "id": 9,
                        "text": "Personal Computer/Laptop",
                        "label": "Personal Computer/Laptop",
                        "miscellaneous": {
                            "img_url": "sec/sec_laptop.png"
                        },
                        "img_url": "sec/sec_laptop.png",
                        "locale": {}
                    },
                    {
                        "id": 10,
                        "text": "Washing Machine",
                        "label": "Washing Machine",
                        "miscellaneous": {
                            "img_url": "sec/sec_washing.png"
                        },
                        "img_url": "sec/sec_washing.png",
                        "locale": {}
                    },
                    {
                        "id": 11,
                        "text": "Air Conditioner",
                        "label": "Air Conditioner",
                        "miscellaneous": {
                            "img_url": "sec/sec_ac.png"
                        },
                        "img_url": "sec/sec_ac.png",
                        "locale": {}
                    },
                    {
                        "id": 12,
                        "text": "Car/Jeep/Van",
                        "label": "Car/Jeep/Van",
                        "miscellaneous": {
                            "img_url": "sec/sec_car.png"
                        },
                        "img_url": "sec/sec_car.png",
                        "locale": {}
                    },
                    {
                        "id": 13,
                        "text": "Agricultural Land",
                        "label": "Agricultural Land",
                        "miscellaneous": {
                            "img_url": "sec/sec_agriculture.png"
                        },
                        "img_url": "sec/sec_agriculture.png",
                        "locale": {}
                    }
                ],
                "misc": {
                    "text": "Which of these ITEMS do you have at home? (It could be owned by you, your family, the owner of the house, or provided by your employer)",
                    "colspan": 2
                }
            },
            {
                "question_id": 9,
                "question_label": "SEC-C",
                "question_name": "sec-c",
                "question_type": "multiple-choice-single",
                "question_text": "What is the highest education of the PERSON WHO MAKES the biggest contribution to the running of the household?",
                "colspan": 1,
                "options": [
                    {
                        "id": 14,
                        "text": "Graduate / Post Graduate -Professional",
                        "label": "Graduate / Post Graduate -Professional",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 15,
                        "text": "Graduate / Post Graduate - General",
                        "label": "Graduate / Post Graduate - General",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 16,
                        "text": "Some College (including a Diploma) but not graduate",
                        "label": "Some College (including a Diploma) but not graduate",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 17,
                        "text": "SSC / HSC",
                        "label": "SSC / HSC",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 18,
                        "text": "School 5 to 9 years",
                        "label": "School 5 to 9 years",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 19,
                        "text": "Literate but no formal schooling / School up to 4 years",
                        "label": "Literate but no formal schooling / School up to 4 years",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 20,
                        "text": "Illiterate",
                        "label": "Illiterate",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 141,
                        "text": "Graduate / Post Graduate -Professional1",
                        "label": "Graduate / Post Graduate -Professional1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 151,
                        "text": "Graduate / Post Graduate - General1",
                        "label": "Graduate / Post Graduate - General1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 161,
                        "text": "Some College (including a Diploma) but not graduate1",
                        "label": "Some College (including a Diploma) but not graduate1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 171,
                        "text": "SSC / HSC1",
                        "label": "SSC / HSC1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 181,
                        "text": "School 5 to 9 years1",
                        "label": "School 5 to 9 years1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 191,
                        "text": "Literate but no formal schooling / School up to 4 years1",
                        "label": "Literate but no formal schooling / School up to 4 years1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 201,
                        "text": "Illiterate1",
                        "label": "Illiterate1",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    }
                ],
                "misc": {
                    "text": "What is the highest education of the PERSON WHO MAKES the biggest contribution to the running of the household?"
                }
            },
            {
                "question_id": 81,
                "question_label": "SEC-D",
                "question_name": "sec-d",
                "question_type": "multiple-choice-single",
                "question_text": "Which of these ITEMS do you have at home? (It could be owned by you, your family, the owner of the house, or provided by your employer)",
                "colspan": 2,
                "options": [
                    {
                        "id": 3,
                        "text": "Electricity Connection",
                        "label": "Electricity Connection",
                        "miscellaneous": {
                            "img_url": "sec/sec_electricity.png"
                        },
                        "img_url": "sec/sec_electricity.png",
                        "locale": {}
                    },
                    {
                        "id": 4,
                        "text": "Ceiling Fan",
                        "label": "Ceiling Fan",
                        "miscellaneous": {
                            "img_url": "sec/sec_fan.png"
                        },
                        "img_url": "sec/sec_fan.png",
                        "locale": {}
                    },
                    {
                        "id": 5,
                        "text": "LPG Stove",
                        "label": "LPG Stove",
                        "miscellaneous": {
                            "img_url": "sec/sec_gas.png"
                        },
                        "img_url": "sec/sec_gas.png",
                        "locale": {}
                    },
                    {
                        "id": 6,
                        "text": "Two Wheeler",
                        "label": "Two Wheeler",
                        "miscellaneous": {
                            "img_url": "sec/sec_bike.png"
                        },
                        "img_url": "sec/sec_bike.png",
                        "locale": {}
                    },
                    {
                        "id": 7,
                        "text": "Color TV",
                        "label": "Color TV",
                        "miscellaneous": {
                            "img_url": "sec/sec_tv.png"
                        },
                        "img_url": "sec/sec_tv.png",
                        "locale": {}
                    },
                    {
                        "id": 8,
                        "text": "Refrigerator",
                        "label": "Refrigerator",
                        "miscellaneous": {
                            "img_url": "sec/sec_fridge.png"
                        },
                        "img_url": "sec/sec_fridge.png",
                        "locale": {}
                    },
                    {
                        "id": 9,
                        "text": "Personal Computer/Laptop",
                        "label": "Personal Computer/Laptop",
                        "miscellaneous": {
                            "img_url": "sec/sec_laptop.png"
                        },
                        "img_url": "sec/sec_laptop.png",
                        "locale": {}
                    },
                    {
                        "id": 10,
                        "text": "Washing Machine",
                        "label": "Washing Machine",
                        "miscellaneous": {
                            "img_url": "sec/sec_washing.png"
                        },
                        "img_url": "sec/sec_washing.png",
                        "locale": {}
                    },
                    {
                        "id": 11,
                        "text": "Air Conditioner",
                        "label": "Air Conditioner",
                        "miscellaneous": {
                            "img_url": "sec/sec_ac.png"
                        },
                        "img_url": "sec/sec_ac.png",
                        "locale": {}
                    },
                    {
                        "id": 12,
                        "text": "Car/Jeep/Van",
                        "label": "Car/Jeep/Van",
                        "miscellaneous": {
                            "img_url": "sec/sec_car.png"
                        },
                        "img_url": "sec/sec_car.png",
                        "locale": {}
                    },
                    {
                        "id": 13,
                        "text": "Agricultural Land",
                        "label": "Agricultural Land",
                        "miscellaneous": {
                            "img_url": "sec/sec_agriculture.png"
                        },
                        "img_url": "sec/sec_agriculture.png",
                        "locale": {}
                    }
                ],
                "misc": {
                    "text": "Which of these ITEMS do you have at home? (It could be owned by you, your family, the owner of the house, or provided by your employer)",
                    "colspan": 2
                }
            },
            {
                "question_id": 12,
                "question_label": "M_LSM_Q1",
                "question_name": "m_lsm_q1",
                "question_type": "multiple-choice-single",
                "question_text": "Which of these best describes the highest level of education of the chief wage earner or head of your household?",
                "colspan": 1,
                "options": [
                  {
                    "id": 33,
                    "text": "Post graduate studies complete (post graduate degree)",
                    "label": "Post graduate studies complete (post graduate degree)",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 34,
                    "text": "Post graduate studies incomplete (no post graduate degree)",
                    "label": "Post graduate studies incomplete (no post graduate degree)",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 35,
                    "text": "College / university complete(graduate)",
                    "label": "College / university complete(graduate)",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 36,
                    "text": "College / university incomplete",
                    "label": "College / university incomplete",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 37,
                    "text": "Secondary / senior / high school complete",
                    "label": "Secondary / senior / high school complete",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 38,
                    "text": "Below Secondary / senior / high school",
                    "label": "Below Secondary / senior / high school",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 331,
                    "text": "Post graduate studies complete (post graduate degree)1",
                    "label": "Post graduate studies complete (post graduate degree)1",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 341,
                    "text": "Post graduate studies incomplete (no post graduate degree)1",
                    "label": "Post graduate studies incomplete (no post graduate degree)1",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 351,
                    "text": "College / university complete(graduate)1",
                    "label": "College / university complete(graduate)1",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 361,
                    "text": "College / university incomplete1",
                    "label": "College / university incomplete1",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 371,
                    "text": "Secondary / senior / high school complete1",
                    "label": "Secondary / senior / high school complete1",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  },
                  {
                    "id": 381,
                    "text": "Below Secondary / senior / high school1",
                    "label": "Below Secondary / senior / high school1",
                    "miscellaneous": null,
                    "img_url": null,
                    "locale": {}
                  }
                ],
                "misc": {
                  "text": "Which of these best describes the highest level of education of the chief wage earner or head of your household?"
                }
            },
            {
                "question_id": 13,
                "question_label": "M_LSM_Q2",
                "question_name": "m_lsm_q2",
                "question_type": "multiple-choice-multiple-select",
                "question_text": "Which of these items do you have in working order in your home?",
                "colspan": 2,
                "options": [
                    {
                    "id": 39,
                    "text": "Air conditioning (built in NOT portable)",
                    "label": "Air conditioning (built in NOT portable)",
                    "miscellaneous": {
                        "img_url": "sec/sec_ac.png"
                    },
                    "img_url": "sec/sec_ac.png",
                    "locale": {}
                    },
                    {
                    "id": 40,
                    "text": "Kitchen sink",
                    "label": "Kitchen sink",
                    "miscellaneous": {
                        "img_url": "mlsm/sink.png"
                    },
                    "img_url": "mlsm/sink.png",
                    "locale": {}
                    },
                    {
                    "id": 41,
                    "text": "Dining table",
                    "label": "Dining table",
                    "miscellaneous": {
                        "img_url": "mlsm/table.png"
                    },
                    "img_url": "mlsm/table.png",
                    "locale": {}
                    },
                    {
                    "id": 42,
                    "text": "Refrigerator(Stand alone – this may have ice box but NOT separate freezer section with its own door)",
                    "label": "Refrigerator(Stand alone – this may have ice box but NOT separate freezer section with its own door)",
                    "miscellaneous": {
                        "img_url": "mlsm/refrigerator.png"
                    },
                    "img_url": "mlsm/refrigerator.png",
                    "locale": {}
                    },
                    {
                    "id": 43,
                    "text": "Fridge freezer (i.e. the freezer section has its own door,separate from the refrigerator door)",
                    "label": "Fridge freezer (i.e. the freezer section has its own door,separate from the refrigerator door)",
                    "miscellaneous": {
                        "img_url": "sec/sec_fridge.png"
                    },
                    "img_url": "sec/sec_fridge.png",
                    "locale": {}
                    },
                    {
                    "id": 44,
                    "text": "Microwave oven",
                    "label": "Microwave oven",
                    "miscellaneous": {
                        "img_url": "mlsm/oven.png"
                    },
                    "img_url": "mlsm/oven.png",
                    "locale": {}
                    },
                    {
                    "id": 45,
                    "text": "Washing machine",
                    "label": "Washing machine",
                    "miscellaneous": {
                        "img_url": "sec/sec_washing.png"
                    },
                    "img_url": "sec/sec_washing.png",
                    "locale": {}
                    },
                    {
                    "id": 46,
                    "text": "Water filtering device",
                    "label": "Water filtering device",
                    "miscellaneous": {
                        "img_url": "mlsm/filter.png"
                    },
                    "img_url": "mlsm/filter.png",
                    "locale": {}
                    },
                    {
                    "id": 47,
                    "text": "Telephone (landline)",
                    "label": "Telephone (landline)",
                    "miscellaneous": {
                        "img_url": "mlsm/landline.png"
                    },
                    "img_url": "mlsm/landline.png",
                    "locale": {}
                    },
                    {
                    "id": 48,
                    "text": "Home cinema/theatre / entertainment centre / HDD multimedia player",
                    "label": "Home cinema/theatre / entertainment centre / HDD multimedia player",
                    "miscellaneous": {
                        "img_url": "mlsm/multimedia.png"
                    },
                    "img_url": "mlsm/multimedia.png",
                    "locale": {}
                    },
                    {
                    "id": 49,
                    "text": "Motor cars",
                    "label": "Motor cars",
                    "miscellaneous": {
                        "img_url": "mlsm/cab.png"
                    },
                    "img_url": "mlsm/cab.png",
                    "locale": {}
                    },
                    {
                    "id": 50,
                    "text": "PC / desktop computers",
                    "label": "PC / desktop computers",
                    "miscellaneous": {
                        "img_url": "mlsm/desktop.png"
                    },
                    "img_url": "mlsm/desktop.png",
                    "locale": {}
                    },
                    {
                    "id": 51,
                    "text": "Laptop computers",
                    "label": "Laptop computers",
                    "miscellaneous": {
                        "img_url": "sec/sec_laptop.png"
                    },
                    "img_url": "sec/sec_laptop.png",
                    "locale": {}
                    },
                    {
                    "id": 52,
                    "text": "Still cameras (digital)",
                    "label": "Still cameras (digital)",
                    "miscellaneous": {
                        "img_url": "mlsm/stillcameras.png"
                    },
                    "img_url": "mlsm/stillcameras.png",
                    "locale": {}
                    },
                    {
                    "id": 53,
                    "text": "Video cameras (digital)",
                    "label": "Video cameras (digital)",
                    "miscellaneous": {
                        "img_url": "mlsm/camera.png"
                    },
                    "img_url": "mlsm/camera.png",
                    "locale": {}
                    },
                    {
                    "id": 54,
                    "text": "Colour TVs CRT (cathode ray tube)",
                    "label": "Colour TVs CRT (cathode ray tube)",
                    "miscellaneous": {
                        "img_url": "mlsm/crt.png"
                    },
                    "img_url": "mlsm/crt.png",
                    "locale": {}
                    },
                    {
                    "id": 55,
                    "text": "Colour TVs LCD / Plasma TVs",
                    "label": "Colour TVs LCD / Plasma TVs",
                    "miscellaneous": {
                        "img_url": "mlsm/plasma.png"
                    },
                    "img_url": "mlsm/plasma.png",
                    "locale": {}
                    }
                ],
                "misc": {
                    "text": "Which of these items do you have in working order in your home?",
                    "colspan": 2
                }
            },
            {
                "question_id": 1,
                "question_label": "Gender",
                "question_name": "gender",
                "question_type": "single-select",
                "question_text": "What is your Gender?",
                "colspan": 1,
                "options": [
                    {
                        "id": 1,
                        "text": "Male",
                        "label": "male",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    },
                    {
                        "id": 2,
                        "text": "Female",
                        "label": "female",
                        "miscellaneous": null,
                        "img_url": null,
                        "locale": {}
                    }
                ],
                "misc": {
                    "text": "What is your Gender?"
                }
            }
        ]
    }
  }

}
